import { combineReducers, ReducersMapObject } from 'redux';

import { WidgetBlock } from '../WidgetBlocks/types/IWidgetBlock';
import buildReducerFunction from './WidgetBlockReducer';

const constructStore = (allWidgetBlocks: WidgetBlock[], otherReducerFunctions: ReducersMapObject = {}) => {
    const reducers: ReducersMapObject = Object.assign(
        {
            widgetBlocks: buildReducerFunction(allWidgetBlocks),
        },
        otherReducerFunctions
    );

    // console.log(`Combined Reducers: ${JSON.stringify(Object.keys(reducers))}`)
    return combineReducers(reducers);
};

export { constructStore };
